import React from 'react';
import './section1.css'
import img1 from '../../asserts/img1.png'
import Title from '../common/title';
import Text from '../common/text';
import Btn from '../common/btn';
import star from '../../asserts/star.png'

const Secone = () => {
    return ( <>
    <section className='sec1'>
        <article className='sec1-div'>
            <p className='smalltext'>welcome to our world</p>
            <Title title='Now You Can Find Your Dream Home in Nature’s Embrace ' t='title' />
            <Text text='Discover your dream home in the heart of scenic beauty, crafted for a life of elegance and comfort Discover your dream home in the heart of scenic beauty, crafted for a life of elegance and comfort Discover a lifestyle of elegance and serenity at Golden Hills Villas. Each villa is meticulously designed to offer luxurious living spaces, stunning views, and the privacy you desire. ' x='text'  />
<Btn btn='Explore Now' />
<img className='star' src={star} alt="" />
        </article>
            <img className='hero-img' src={img1} alt="" />

    </section>
    </> );
}
 
export default Secone;
